import React from 'react'

import { LastName as CoreLastName, Util } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

const { isText, maxLength, minLength } = Util.validations

export const LastName = () => {
  const { getLabel } = useIntl()

  return (
    <CoreLastName
      label={getLabel('checkout.contact.lastName')}
      errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
      validations={[minLength(2), maxLength(30), isText]}
    />
  )
}
